import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import axios from "./apiAxios.js";

const fail = (err, rejectWithValue) => {
	const message = err?.response?.data?.message || err.message || "Request failed";
	notification.error({ message: "Promotions", description: message, duration: 4 });
	return rejectWithValue(message);
};

export const fetchPromotions = createAsyncThunk(
	"promotions/list",
	async (organizationId, { rejectWithValue }) => {
		try {
			const { data } = await axios.get(`/org/promotions/${organizationId}`);
			return data;
		} catch (err) {
			return fail(err, rejectWithValue);
		}
	}
);

export const savePromotion = createAsyncThunk(
	"promotions/save",
	async ({ organizationId, promotionId, payload }, { rejectWithValue }) => {
		try {
			const { data } = promotionId
				? await axios.put(`/org/promotions/${organizationId}/${promotionId}`, payload)
				: await axios.post(`/org/promotions/${organizationId}`, payload);
			notification.success({ message: "Promotion saved", duration: 2 });
			return data;
		} catch (err) {
			return fail(err, rejectWithValue);
		}
	}
);

export const deletePromotion = createAsyncThunk(
	"promotions/delete",
	async ({ organizationId, promotionId }, { rejectWithValue }) => {
		try {
			const { data } = await axios.delete(
				`/org/promotions/${organizationId}/${promotionId}`
			);
			notification.success({ message: "Promotion deleted", duration: 2 });
			return data;
		} catch (err) {
			return fail(err, rejectWithValue);
		}
	}
);

const promotionsSlice = createSlice({
	name: "promotions",
	initialState: {
		list: [],
		loading: false,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchPromotions.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchPromotions.fulfilled, (state, action) => {
				state.loading = false;
				state.list = action.payload || [];
			})
			.addCase(fetchPromotions.rejected, (state) => {
				state.loading = false;
			});
	},
});

export default promotionsSlice.reducer;
